import styled from 'styled-components';
import { breakpoints } from '@src/common/breakpoints';

export const ValueDisplay = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 24px;
`;

export const Label = styled('h3')``;

export const Value = styled('p')``;

export const StyleWrapper = styled('div')`
  margin: 0 !important;
  width: 100%;
  max-width: 100% !important;

  .planne-widget-checkout-form-row {
    input {
      height: 45px;
      margin-bottom: 0px;
      padding-right: 15px;
      padding-left: 15px;
      border-style: solid;
      border-width: 1px;
      border-color: hsla(0, 0%, 50.6%, 0.5);
      border-radius: 4px;
      background-color: #fff;
      -webkit-transition: all 270ms ease;
      transition: all 270ms ease;
      color: #818181;
    }

    select {
      height: 45px;
    }
  }

  .planne-widget-checkout-input-field {
    span {
      width: 100%;
      display: block;
      text-align: center;
      color: #fd5f60;
      padding-top: 5px;
      border-radius: 2px;
    }
  }

  .planne-button {
    padding: 14px 35px;
    background-color: #3f09c8;
    cursor: pointer;
    display: inline-block;
    border: 0;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
    text-transform: uppercase;
    color: #fff;

    &.planne-border-button {
      background-color: #fff;
      border: 1px solid;
      border-color: #3f09c8;
      color: #3f09c8;
    }

    @media (max-width: ${breakpoints.smallTablet}) {
      &.planne-sale-outside-button,
      &.planne-sale-inside-button {
        width: 100%;
      }
    }
  }

  .planne-widget-checkout-payment-root {
    .planne-widget-checkout-payment-selectors {
      a {
        cursor: pointer;
      }
    }
  }

  .planne-line-through {
    text-decoration: line-through;
  }

  .planne-widget-sale-sale-info {
    p {
      color: #818181;
    }
  }
  .planne-widget-sale-voucher-row .planne-widget-sale-reservation-row {
    label {
      display: block;
      margin-bottom: 5px;
      font-weight: bold;
    }
  }
`;
